
export const NOF_CONFIGURE_THRESHOLD_PERMISSION: string[] = [ 'NOF_SEUILS_ALERTE', 'NOF_ADMIN'];
export const NOF_PUSH_NOTIFICATION_PERMISSION: string[] = [ 'NOF_PUSH_NOTIFICATION', 'NOF_ADMIN'];
